import React from 'react';
import { Typography } from 'antd';
import AppointmentScheduler from '../components/AppointmentScheduler'; // Import the scheduler component

const { Title } = Typography;

const AppointmentPage = () => {
  return (
    <div>
      <Title level={2}>Appointment Scheduler</Title>
      <AppointmentScheduler />
    </div>
  );
};

export default AppointmentPage;
